import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import React, { useEffect, useMemo, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import { Formik, Form, Field, ErrorMessage, FieldArray, getIn } from "lib/formik"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import Select from "components/Shared/TranslatedSelect"
import { getCategories } from "store/actions/categoriesAction"
import { getItemsListDropdown } from "store/actions/itemsAction"
import { addPromotionSchema } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { getAllBranchs } from "store/actions/usersAction"
import {
  addPromotion,
  getPromotionDetails,
  updatePromotion,
} from "store/actions/promotionsAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { allOption } from "components/Common/constants"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import { getCountryList } from "store/actions/countriesAction"
import { getPosDiscounts } from "store/actions/posAction"
import { getSubPermissions } from "common/isPermissionEnabled"
import {
  isOrderTypeAllowedByPlan,
  sanitizeOrderTypesByPlan,
} from "utils/fulfillmentPermissions"
import { getCrossModuleFilterPermissions } from "utils/crossModuleFilterPermissions"

const DISCOUNT_ORDER_TYPE_OPTIONS = [
  { value: "pickup", labelKey: "Pickup" },
  { value: "curbside", labelKey: "Curbside" },
  { value: "delivery", labelKey: "Delivery" },
]

const initialValues = {
  name: "",
  offerType: "discount",
  // item: {
  category: "",
  item: "",
  offerPrice: null,
  quantity: null,
  // },
  qualificationType: "order",
  qualificationItems: [],
  cartRules: [],
  availableBranches: [],
  discountType: "fixed",
  // orderType: [],
  amount: null,
  maxAmount: null,
  limits: {
    isMaxUsageOfCustomers: false,
    maxUsageOfCustomers: null,
    isMaxUsagePerCustomer: false,
    maxUsagePerCustomer: null,
  },
  status: 1,
  minimumCartAmount: null,
  countryCode: "",
  reference: "",
  manualConditions: [],
  maximumCartAmount: null,
  discountLimits: {
    isMaxDiscountAmountPerCustomer: false,
    maxDiscountAmountPerCustomer: null,
  },
}

const AddPromotion = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${
    mode === "add" ? t("Add") : t("Edit")
  } ${"Discount "}`

  // const navigate = useNavigate()

  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const [formValues, setFormValues] = useState(initialValues)
  const [isAdvanceSettings, setIsAdvanceSettings] = useState(false)
  const [isLinkWithPos, setIsLinkWithPos] = useState(false)
  const [orderType, setOrderType] = useState(["curbside", "pickup"])
  const { loading, isLoading, promotionDetails } = useSelector(
    state => state.Promotions
  )
  const { countryList } = useSelector(state => state.Countries)
  const { posDiscounts } = useSelector(state => state.POS)
  const { userRole, accountType, accountScope } = useSelector(
    state => state.Login
  )
  const { canFilterByBranch, canFilterByMenus } = getCrossModuleFilterPermissions(
    userRole,
    accountType,
    accountScope
  )

  const promotionPermissionId = mode === "add" ? "promotion_2" : "promotion_3"

  const canLinkWithPos = useMemo(() => {
    const promotionSubs =
      getSubPermissions(
        userRole,
        14,
        promotionPermissionId,
        accountType,
        accountScope
      ) || {}
    return promotionSubs.link_discount_with_pos?.isEnabled === true
  }, [userRole, accountType, accountScope, promotionPermissionId])

  // Same plan/role fulfillment gates as add/edit branch (branchLocations_3).
  const branchFulfillmentPermissions = useMemo(
    () =>
      getSubPermissions(
        userRole,
        5,
        "branchLocations_3",
        accountType,
        accountScope
      ) || {},
    [userRole, accountType, accountScope]
  )

  const allowedOrderTypeOptions = useMemo(
    () =>
      DISCOUNT_ORDER_TYPE_OPTIONS.filter(option =>
        isOrderTypeAllowedByPlan(branchFulfillmentPermissions, option.value)
      ),
    [branchFulfillmentPermissions]
  )

  useEffect(() => {
    setOrderType(prev =>
      sanitizeOrderTypesByPlan(prev, branchFulfillmentPermissions)
    )
  }, [branchFulfillmentPermissions])

  useEffect(() => {
    const fetchCountryList = () => {
      dispatch(getCountryList())
    }
    fetchCountryList()
  }, [])

  useEffect(() => {
    const fetchPromotionDetails = () => {
      const payload = {
        id,
      }
      dispatch(getPromotionDetails(payload))
    }
    if (mode === "edit") {
      fetchPromotionDetails()
    }
  }, [])

  useEffect(() => {
    if (promotionDetails && mode === "edit") {
      const {
        item,
        limits,
        name,
        offerType,
        qualificationType,
        qualificationItems,
        discountType,
        amount,
        maxAmount,
        minimumCartAmount,
        cartRules,
        orderType,
        availableBranches,
        hasAdvancedSettings,
        countryCode,
        maximumCartAmount,
        discountLimits,
        reference,
      } = promotionDetails

      const updatedAvailableBranches = availableBranches?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      }))

      var updatedQualificationItems = []

      if (qualificationItems && qualificationItems.length > 0) {
        const data = qualificationItems.map(item => ({
          label:
            language === "sa"
              ? item?.categoryId?.nameAr
              : item?.categoryId?.name || "",
          value: item?.categoryId?._id || "",
          category: {
            label:
              language === "sa"
                ? item?.categoryId?.nameAr
                : item?.categoryId?.name || "",
            value: item?.categoryId?._id || "",
          },
          item: {
            label:
              language === "sa"
                ? item?.itemId?.nameAr
                : item?.itemId?.name || "",
            value: item?.itemId?._id || "",
          },
        }))
        updatedQualificationItems = data
      }
      setOrderType(
        sanitizeOrderTypesByPlan(orderType, branchFulfillmentPermissions)
      )

      const selectedCountry = countryList?.find(
        country => country.countryCode === countryCode
      )

      let countryObj = ""
      if (selectedCountry) {
        countryObj = {
          label:
            language === "sa" ? selectedCountry.nameAr : selectedCountry.name,
          value: selectedCountry.countryCode,
        }
      }
      setIsLinkWithPos(canLinkWithPos ? Boolean(reference) : false)
      const updatedDiscountLimits = {
        isMaxDiscountAmountPerCustomer:
          discountLimits?.isMaxDiscountAmountPerCustomer,
        maxDiscountAmountPerCustomer:
          discountLimits?.maxDiscountAmountPerCustomer,
      }
      setFormValues(prevVal => ({
        ...prevVal,
        name,
        offerType,
        qualificationType,
        amount,
        maxAmount,
        limits,
        minimumCartAmount,
        discountType,
        availableBranches: updatedAvailableBranches,
        qualificationItems: updatedQualificationItems,
        countryCode: countryObj,
        maximumCartAmount,
        discountLimits: updatedDiscountLimits,
      }))
      setIsAdvanceSettings(hasAdvancedSettings)
    }
  }, [promotionDetails, mode, language, countryList, canLinkWithPos])

  useEffect(() => {
    if (!canLinkWithPos) {
      setIsLinkWithPos(false)
    }
  }, [canLinkWithPos])

  useEffect(() => {
    if (promotionDetails && mode === "edit" && isLinkWithPos && canLinkWithPos) {
      const { reference, referenceName, manualConditions } = promotionDetails
      if (!reference) {
        setFormValues(prevVal => ({
          ...prevVal,
          reference: "",
          manualConditions: manualConditions || [],
        }))
        return
      }

      const selectedReference = posDiscounts?.find(
        item => item.id === reference
      )
      if (selectedReference) {
        setFormValues(prevVal => ({
          ...prevVal,
          reference: {
            label: selectedReference.name,
            value: selectedReference.id,
          },
          manualConditions,
          discountType:
            selectedReference.mode === "Percent" ? "percentage" : "fixed",
          amount:
            selectedReference.mode === "Percent"
              ? selectedReference.percent
              : selectedReference.sum,
          maxAmount:
            selectedReference.mode === "Percent" ? selectedReference.sum : null,
        }))
      } else {
        setFormValues(prevVal => ({
          ...prevVal,
          reference: {
            label: referenceName || reference,
            value: reference,
          },
          manualConditions,
        }))
      }
    }
  }, [posDiscounts, isLinkWithPos, canLinkWithPos])

  useEffect(() => {
    if (canFilterByMenus) {
      dispatch(getCategories({ isCombo: false }))
    }
  }, [canFilterByMenus, dispatch])

  const { allCategories } = useSelector(state => state.Categories)
  const { itemsListDropdown } = useSelector(state => state.Items)
  const { branchsList } = useSelector(state => state.Users)

  const allItemsList = value => {
    if (!canFilterByMenus) return
    const payload = {
      category: [value],
    }
    dispatch(getItemsListDropdown(payload))
  }

  useEffect(() => {
    if (canFilterByBranch) {
      dispatch(getAllBranchs())
    }
  }, [canFilterByBranch, dispatch])

  const handleCheckboxChange = e => {
    const { value, checked } = e.target
    if (checked) {
      setOrderType(prevOrderType => [...prevOrderType, value])
    } else {
      setOrderType(prevOrderType => prevOrderType.filter(v => v !== value))
    }
  }

  const handleOnSubmit = values => {
    const {
      name,
      offerType,
      category,
      item,
      offerPrice,
      quantity,
      qualificationType,
      qualificationItems,
      cartRules,
      availableBranches,
      discountType,
      amount,
      maxAmount,
      limits,
      status,
      minimumCartAmount,
      countryCode,
      reference,
      manualConditions,
      maximumCartAmount,
      discountLimits,
    } = values

    const transformedQualificationType =
      offerType === "discount" ? qualificationType : ""

    const transformedItem =
      offerType === "item"
        ? {
            categoryId: category.value,
            itemId: item?.value,
            offerPrice,
            quantity,
          }
        : {}

    const transformedQualificationItems = qualificationItems?.map(item => {
      const baseObject = {
        categoryId: item?.category?.value,
      }

      if (offerType === "item") {
        baseObject.itemId = item?.item?.value
      }

      return baseObject
    })

    const transformedCartRules = isAdvanceSettings
      ? cartRules?.map(item => ({
          categoryId: item?.category?.value,
          itemId: item?.item?.value,
          quantity: item.quantity,
        }))
      : []

    const transformedAvailableBranches = isAdvanceSettings
      ? availableBranches?.map(item => item.value)
      : []

    const payload = {
      name,
      offerType,
      // item: transformedItem,
      qualificationType: transformedQualificationType,
      qualificationItems: transformedQualificationItems,
      cartRules: transformedCartRules,
      availableBranches: transformedAvailableBranches,
      discountType: discountType,
      orderType: isAdvanceSettings ? orderType : [], // HAVE TO CHECK
      amount: amount ?? 0,
      maxAmount: maxAmount ?? 0,
      hasAdvancedSettings: isAdvanceSettings,
      limits: {
        isMaxUsageOfCustomers: limits.isMaxUsageOfCustomers,
        maxUsageOfCustomers: limits.maxUsageOfCustomers,
        isMaxUsagePerCustomer: limits.isMaxUsagePerCustomer,
        maxUsagePerCustomer: limits.maxUsagePerCustomer,
      },
      // status: 1, // It will be always 1
      minimumCartAmount:
        offerType === "item" || offerType === "category"
          ? 0
          : minimumCartAmount,
      countryCode: countryCode.value,
      reference:
        canLinkWithPos && isLinkWithPos
          ? reference?.value || ""
          : mode === "edit" && promotionDetails?.reference
          ? promotionDetails.reference
          : "",
      referenceName:
        canLinkWithPos && isLinkWithPos
          ? reference?.label || ""
          : mode === "edit" && promotionDetails?.referenceName
          ? promotionDetails.referenceName
          : "",
      manualConditions:
        canLinkWithPos && isLinkWithPos
          ? manualConditions || []
          : mode === "edit" && promotionDetails?.manualConditions
          ? promotionDetails.manualConditions
          : [],
      maximumCartAmount,
      discountLimits,
    }

    if (mode === "add") {
      dispatch(addPromotion(payload))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            window.history.back()
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      payload.id = id
      dispatch(updatePromotion(payload))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            window.history.back()
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const [isAllSelected, setIsAllSelected] = useState(false)

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  const fetchPosDiscounts = (code, showError = true) => {
    const payload = {
      countryCode: code,
    }
    dispatch(getPosDiscounts(payload))
      .then(action => {
        const { statusCode, success, msg, message } = action?.payload
        if (statusCode === 200 && success) {
        } else if (showError) {
          dispatch(showAlert({ text: msg || message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" ? t("Add") : t("Edit")} {t("Discount")}
                </CardTitle>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <CardTitle>{t("Offer")}</CardTitle>
                  <div className="d-flex align-items-center">
                    <label className="mx-2 mb-0">{t("Advance Settings")}</label>
                    <Switch
                      isChecked={isAdvanceSettings}
                      onClickHandler={() => {
                        setIsAdvanceSettings(!isAdvanceSettings)
                      }}
                    />
                  </div>
                </div>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addPromotionSchema()}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => {
                    const isPosLinked =
                      canLinkWithPos &&
                      isLinkWithPos &&
                      Boolean(values.reference?.value)

                    const handleLinkWithPosToggle = () => {
                      const nextValue = !isLinkWithPos
                      setIsLinkWithPos(nextValue)
                      if (!nextValue) {
                        setFieldValue("reference", "")
                        setFieldValue("manualConditions", [])
                      } else if (mode === "edit" && promotionDetails?.reference) {
                        const {
                          reference: savedReference,
                          referenceName,
                          manualConditions,
                        } = promotionDetails
                        setFieldValue("reference", {
                          label: referenceName || savedReference,
                          value: savedReference,
                        })
                        setFieldValue("manualConditions", manualConditions || [])
                      }
                    }

                    return (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Discount Name")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Discount Name")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <TextError name="name" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mt-3">
                            <label htmlFor="name">{t("Offer Type")}</label>
                            <div className="d-flex ">
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeDiscount"
                                  value="discount"
                                  onClick={() => {
                                    setFieldValue("offerType", "discount")
                                    setFieldValue("qualificationItems", [])
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeDiscount"
                                >
                                  {t("Discount")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeCategory"
                                  value="category"
                                  onClick={() => {
                                    setFieldValue("offerType", "category")
                                    setFieldValue("qualificationItems", [
                                      {
                                        category: null,
                                      },
                                    ])
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeCategory"
                                >
                                  {t("Category")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeItem"
                                  value="item"
                                  onClick={() => {
                                    setFieldValue("offerType", "item")
                                    setFieldValue("qualificationItems", [
                                      {
                                        category: null,
                                        item: null,
                                      },
                                    ])
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeItem"
                                >
                                  {t("Item")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="countryCode">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Country")}
                            </label>
                          </div>
                          <Select
                            value={values.countryCode}
                            onChange={item => {
                              setFieldValue("countryCode", item)
                              if (isLinkWithPos) {
                                setFieldValue("reference", "")
                                setFieldValue("manualConditions", [])
                                if (isPosLinked) {
                                  setFieldValue("amount", null)
                                  setFieldValue("discountType", "fixed")
                                }
                              }
                            }}
                            options={countryList?.map(item => ({
                              label:
                                language === "sa" ? item.nameAr : item.name,
                              value: item.countryCode,
                            }))}
                            className={`select2-selection ${
                              touched.countryCode && errors.countryCode
                                ? "danger_color_border"
                                : ""
                            }`}
                            placeholder={t(`Select Country`)}
                            noOptionsMessage={() => t("No options")}
                          />
                          <TextError name="countryCode" />
                        </div>
                        {canLinkWithPos && (
                        <div className="col-lg-6">
                          <div className="form_field d-flex align-items-center mt-4">
                            <label className="mb-0 me-2">
                              {t("Link with POS")}
                            </label>
                            <Switch
                              isChecked={isLinkWithPos}
                              onClickHandler={handleLinkWithPosToggle}
                            />
                          </div>
                          <small className="text-muted d-block">
                            {t("Enable to sync discount with Syrve POS terminal")}
                          </small>
                        </div>
                        )}
                        {canLinkWithPos && isLinkWithPos && (
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="reference">
                              {t("Discount In POS")}
                            </label>
                          </div>
                          <div className="d-flex justify-content-between">
                            <Select
                              value={values.reference}
                              isClearable
                              onMenuOpen={() => {
                                if (values.countryCode?.value) {
                                  fetchPosDiscounts(values.countryCode.value, false)
                                }
                              }}
                              onChange={item => {
                                if (!item) {
                                  setFieldValue("reference", "")
                                  setFieldValue("manualConditions", [])
                                  return
                                }
                                setFieldValue("reference", item)
                                const { data } = item
                                const { mode, percent, sum, manualConditions } =
                                  data
                                setFieldValue(
                                  "manualConditions",
                                  manualConditions
                                )
                                if (mode === "Percent") {
                                  setFieldValue("discountType", "percentage")
                                  setFieldValue("amount", percent)
                                  setFieldValue("maxAmount", sum)
                                } else if (mode === "FixedSum") {
                                  setFieldValue("discountType", "fixed")
                                  setFieldValue("amount", sum)
                                }
                              }}
                              options={posDiscounts?.map(item => ({
                                label: item.name,
                                value: item.id,
                                data: item,
                              }))}
                              className={`select2-selection w-100 ${
                                touched.reference && errors.reference
                                  ? "danger_color_border"
                                  : ""
                              }`}
                              placeholder={t("Discount In POS")}
                              noOptionsMessage={() => t("No options")}
                            />
                            {values.countryCode && (
                              <Button
                                color="primary"
                                className="ms-2"
                                onClick={() =>
                                  fetchPosDiscounts(
                                    values?.countryCode?.value || "",
                                    true
                                  )
                                }
                              >
                                <i className="bx bx-revision fs-5"></i>
                              </Button>
                            )}
                          </div>
                          <TextError name="reference" />
                        </div>
                        )}
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="discountType">
                              {t("Discount Type")}
                            </label>
                            <div className="d-flex">
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="discountType"
                                  id="discountTypeFixed"
                                  value="fixed"
                                  onClick={() => {
                                    setFieldValue("discountType", "fixed")
                                  }}
                                  disabled={isPosLinked}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="discountTypeFixed"
                                >
                                  {t("Fixed Discount")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="discountType"
                                  id="discountTypePercentage"
                                  value="percentage"
                                  onClick={() => {
                                    setFieldValue("discountType", "percentage")
                                  }}
                                  disabled={isPosLinked}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="discountTypePercentage"
                                >
                                  {t("Percentage")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {values.discountType === "fixed" && (
                          <div className="col-lg-6">
                            <div className="form_field">
                              <label htmlFor="amount">
                                <span className="text-danger">*</span>{" "}
                                {t("Amount")}
                              </label>
                              <Field
                                type="number"
                                id="amount"
                                name="amount"
                                readOnly={isPosLinked}
                                disabled={isPosLinked}
                                placeholder={t("Amount")}
                                className={`form-control ${
                                  touched.amount && errors.amount
                                    ? "is-invalid"
                                    : ""
                                }`}
                                pattern="[0-9]*"
                                min="0.01"
                                step="any"
                              />
                              <TextError name="amount" />
                            </div>
                          </div>
                        )}
                        {values.discountType === "percentage" && (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="name">
                                  <span className="text-danger">*</span>{" "}
                                  {t("Amount")}
                                  (%)
                                </label>
                                <Field
                                  type="number"
                                  id="amount"
                                  name="amount"
                                  readOnly={isPosLinked}
                                  disabled={isPosLinked}
                                  placeholder={t("Amount") + "%"}
                                  className={`form-control ${
                                    touched.amount && errors.amount
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  pattern="[0-9]*"
                                  min="0.01"
                                  max="100"
                                  step="any"
                                />
                                <TextError name="amount" />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="maxAmount">
                                  {t("Maximum Discount")}
                                </label>
                                <Field
                                  type="number"
                                  id="maxAmount"
                                  name="maxAmount"
                                  readOnly={isPosLinked}
                                  disabled={isPosLinked}
                                  placeholder={t("Maximum Discount")}
                                  className={`form-control ${
                                    touched.maxAmount && errors.maxAmount
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  pattern="[0-9]*"
                                  min="0"
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {values.offerType === "category" && (
                          <div className="row mt-3">
                            <label htmlFor="">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Categories")}
                            </label>
                            <FieldArray name="qualificationItems">
                              {({ push, remove }) => (
                                <>
                                  {values.qualificationItems &&
                                    values.qualificationItems.length > 0 &&
                                    values.qualificationItems.map(
                                      (rule, index) => (
                                        <div
                                          className="col-lg-6 mt-2 pe-0"
                                          key={index}
                                        >
                                          <div className="d-flex">
                                            <div className="w-100">
                                              <Select
                                                value={
                                                  values.qualificationItems[
                                                    index
                                                  ].category
                                                }
                                                onChange={selectedValue => {
                                                  allItemsList(
                                                    selectedValue.value
                                                  )
                                                  setFieldValue(
                                                    `qualificationItems[${index}].category`,
                                                    selectedValue
                                                  )
                                                  // setFieldValue(
                                                  //   `qualificationItems[${index}].item`,
                                                  //   null
                                                  // )
                                                }}
                                                options={allCategories
                                                  .filter(item => {
                                                    const selectedIds =
                                                      values.qualificationItems
                                                        .map(
                                                          (row, rowIndex) =>
                                                            rowIndex !== index
                                                              ? row?.category
                                                                  ?.value
                                                              : null
                                                        )
                                                        .filter(Boolean)
                                                        .map(String)
                                                    return !selectedIds.includes(
                                                      String(item._id)
                                                    )
                                                  })
                                                  .map(item => ({
                                                    label:
                                                      language === "sa"
                                                        ? item.nameAr
                                                        : item.name,
                                                    value: item._id,
                                                  }))}
                                                placeholder={t(
                                                  "Select Category"
                                                )}
                                                noOptionsMessage={() =>
                                                  t("No options")
                                                }
                                                className={`select2-selection ${
                                                  getIn(
                                                    touched,
                                                    `qualificationItems[${index}].category`
                                                  ) &&
                                                  getIn(
                                                    errors,
                                                    `qualificationItems[${index}].category`
                                                  )
                                                    ? "danger_color_border"
                                                    : ""
                                                }`}
                                              />
                                              <TextError
                                                name={`qualificationItems[${index}].category`}
                                              />
                                            </div>
                                            {values.qualificationItems.length >
                                              1 && (
                                              <div
                                                style={{
                                                  maxWidth: 100,
                                                  marginLeft: 15,
                                                }}
                                              >
                                                <Button
                                                  color="danger"
                                                  type="button"
                                                  onClick={() => remove(index)}
                                                >
                                                  {t("Remove")}
                                                </Button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  <div className="mt-3">
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        push({
                                          category: null,
                                        })
                                      }
                                    >
                                      {t("Add Category")}
                                    </Button>
                                  </div>
                                </>
                              )}
                            </FieldArray>
                          </div>
                        )}

                        {values.offerType === "item" && (
                          <div className="row mt-3">
                            <label htmlFor="">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Categories")}
                            </label>
                            <FieldArray name="qualificationItems">
                              {({ push, remove }) => (
                                <>
                                  {values.qualificationItems &&
                                    values.qualificationItems.length > 0 &&
                                    values.qualificationItems.map(
                                      (rule, index) => (
                                        <div className={`row mt-2`} key={index}>
                                          <div className="col">
                                            <Select
                                              value={
                                                values.qualificationItems[index]
                                                  .category
                                              }
                                              onChange={selectedValue => {
                                                allItemsList(
                                                  selectedValue.value
                                                )
                                                setFieldValue(
                                                  `qualificationItems[${index}].category`,
                                                  selectedValue
                                                )
                                                setFieldValue(
                                                  `qualificationItems[${index}].item`,
                                                  null
                                                )
                                              }}
                                              options={allCategories.map(
                                                item => ({
                                                  label:
                                                    language === "sa"
                                                      ? item.nameAr
                                                      : item.name,
                                                  value: item._id,
                                                })
                                              )}
                                              placeholder={t("Select Category")}
                                              noOptionsMessage={() =>
                                                t("No options")
                                              }
                                              className={`select2-selection ${
                                                getIn(
                                                  touched,
                                                  `qualificationItems[${index}].category`
                                                ) &&
                                                getIn(
                                                  errors,
                                                  `qualificationItems[${index}].category`
                                                )
                                                  ? "danger_color_border"
                                                  : ""
                                              }`}
                                            />
                                            <TextError
                                              name={`qualificationItems[${index}].category`}
                                            />
                                          </div>
                                          <div className="col">
                                            <Select
                                              value={
                                                values.qualificationItems[index]
                                                  .item
                                              }
                                              onChange={selectedValue => {
                                                setFieldValue(
                                                  `qualificationItems[${index}].item`,
                                                  selectedValue
                                                )
                                              }}
                                              options={(itemsListDropdown || [])
                                                .filter(item => {
                                                  const selectedIds =
                                                    values.qualificationItems
                                                      .map((row, rowIndex) =>
                                                        rowIndex !== index
                                                          ? row?.item?.value
                                                          : null
                                                      )
                                                      .filter(Boolean)
                                                      .map(String)
                                                  return !selectedIds.includes(
                                                    String(item._id)
                                                  )
                                                })
                                                .map(item => ({
                                                  label:
                                                    language === "sa"
                                                      ? item.nameAr
                                                      : item.name,
                                                  value: item._id,
                                                }))}
                                              placeholder={t("Select Item")}
                                              noOptionsMessage={() =>
                                                t("No options")
                                              }
                                              className={`select2-selection ${
                                                getIn(
                                                  touched,
                                                  `qualificationItems[${index}].item`
                                                ) &&
                                                getIn(
                                                  errors,
                                                  `qualificationItems[${index}].item`
                                                )
                                                  ? "danger_color_border"
                                                  : ""
                                              }`}
                                            />
                                            <TextError
                                              name={`qualificationItems[${index}].item`}
                                            />
                                            {typeof errors.qualificationItems ===
                                              "string" && index === 0 ? (
                                              <div className="error text-danger">
                                                {t(errors.qualificationItems)}
                                              </div>
                                            ) : null}
                                          </div>
                                          {values.qualificationItems.length >
                                            1 && (
                                            <div
                                              className="col"
                                              style={{ maxWidth: 100 }}
                                            >
                                              <Button
                                                color="danger"
                                                type="button"
                                                onClick={() => remove(index)}
                                              >
                                                {t("Remove")}
                                              </Button>
                                            </div>
                                          )}
                                        </div>
                                      )
                                    )}
                                  <div className="mt-2">
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        push({
                                          category: null,
                                          item: null,
                                        })
                                      }
                                    >
                                      {t("Add")}
                                    </Button>
                                  </div>
                                </>
                              )}
                            </FieldArray>
                          </div>
                        )}
                        {/* </>
                        )} */}

                        {/* ADVANCE SETTINGS */}
                        {isAdvanceSettings && (
                          <>
                            <hr className="mt-3" />
                            {values.offerType === "category" ||
                            values.offerType === "item" ? null : (
                              <>
                                <CardTitle>
                                  {t("Discount Conditions")}
                                </CardTitle>
                                <div className="col-lg-6">
                                  <div className="mt-2">
                                    <div className="form_field">
                                      <label
                                        className="form-check-label"
                                        htmlFor="minimumCartAmount"
                                      >
                                        {t("Minimum Cart Amount")}
                                      </label>
                                      <Field
                                        type="number"
                                        id="minimumCartAmount"
                                        name="minimumCartAmount"
                                        placeholder={t("Minimum Cart Amount")}
                                        className={`form-control ${
                                          touched.minimumCartAmount &&
                                          errors.minimumCartAmount
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        pattern="[0-9]*"
                                        min="0"
                                        step="1"
                                      />
                                      <TextError name="minimumCartAmount" />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form_field">
                                    <label htmlFor="maximumCartAmount">
                                      {t("Maximum Cart Amount")}
                                    </label>
                                    <Field
                                      type="number"
                                      id="maximumCartAmount"
                                      name="maximumCartAmount"
                                      placeholder={t("Maximum Cart Amount")}
                                      className={`form-control ${
                                        touched?.maximumCartAmount &&
                                        errors?.maximumCartAmount
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      pattern="[0-9]*"
                                      min="0"
                                      step="1"
                                    />
                                    <TextError name="maximumCartAmount" />
                                  </div>
                                </div>
                                <div className="mb-2"></div>
                              </>
                            )}

                            <div className="col-lg-12 mt-2">
                              <label htmlFor="name">{t("Order Type")}</label>

                              <div className="d-flex">
                                {allowedOrderTypeOptions.map(
                                  (option, index) => (
                                    <div
                                      key={option.value}
                                      className={`form-check form-check-primary mb-3${
                                        index === 0 ? " ps-0" : ""
                                      }`}
                                    >
                                      <input
                                        type="checkbox"
                                        name="orderType"
                                        value={option.value}
                                        id={option.value}
                                        checked={orderType.includes(
                                          option.value
                                        )}
                                        onChange={handleCheckboxChange}
                                      />
                                      <label
                                        className="form-check-label mx-2"
                                        htmlFor={option.value}
                                      >
                                        {t(option.labelKey)}
                                      </label>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <label htmlFor="">
                                {t("Allow Specific Branches")}
                              </label>
                              <Select
                                value={values.availableBranches}
                                isMulti={true}
                                onChange={selectedValue => {
                                  if (
                                    selectedValue?.find(
                                      option => option.value === "*"
                                    )
                                  ) {
                                    setFieldValue(
                                      "availableBranches",
                                      branchListOptions
                                    )
                                    setIsAllSelected(true)
                                  } else {
                                    setFieldValue(
                                      "availableBranches",
                                      selectedValue
                                    )
                                    setIsAllSelected(
                                      selectedValue.length ===
                                        branchListOptions.length
                                    )
                                  }
                                }}
                                options={options}
                                placeholder={t("Select Branches")}
                                noOptionsMessage={() => t("No options")}
                                className={`select2-selection`}
                              />
                            </div>
                            <hr className="mt-3" />
                            <CardTitle>{t("Redemption")}</CardTitle>
                            <div className="row mb-2" style={{ minHeight: 82 }}>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="amount">
                                    {t("Max Usage Per Customer")}
                                  </label>
                                </div>
                                <Switch
                                  isChecked={
                                    values?.limits?.isMaxUsagePerCustomer
                                  }
                                  onClickHandler={() => {
                                    setFieldValue(
                                      "limits.isMaxUsagePerCustomer",
                                      !values?.limits?.isMaxUsagePerCustomer
                                    )
                                  }}
                                />
                              </div>
                              {values?.limits?.isMaxUsagePerCustomer && (
                                <div className="col-lg-6">
                                  <div className="form_field">
                                    <label htmlFor="maxUsagePerCustomer">
                                      <span className="text-danger">*</span>{" "}
                                      {t("Maximum redemptions per customer")}
                                    </label>
                                    <Field
                                      type="number"
                                      id="maxUsagePerCustomer"
                                      name="limits.maxUsagePerCustomer"
                                      placeholder={t("e.g. 10")}
                                      className={`form-control ${
                                        touched?.limits?.maxUsagePerCustomer &&
                                        errors?.limits?.maxUsagePerCustomer
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      pattern="[0-9]*"
                                      min="0"
                                    />
                                    <TextError name="limits.maxUsagePerCustomer" />
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="row mb-2" style={{ minHeight: 82 }}>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="amount">
                                    {t("Max Usage Of Customers")}
                                  </label>
                                </div>
                                <Switch
                                  isChecked={
                                    values?.limits?.isMaxUsageOfCustomers
                                  }
                                  onClickHandler={() => {
                                    setFieldValue(
                                      "limits.isMaxUsageOfCustomers",
                                      !values?.limits?.isMaxUsageOfCustomers
                                    )
                                  }}
                                />
                              </div>

                              {values?.limits?.isMaxUsageOfCustomers && (
                                <div className="col-lg-6">
                                  <div className="form_field">
                                    <label htmlFor="maxUsageOfCustomers">
                                      <span className="text-danger">*</span>{" "}
                                      {t(
                                        "Maximum redemptions across all customers"
                                      )}
                                    </label>
                                    <Field
                                      type="number"
                                      id="maxUsageOfCustomers"
                                      name="limits.maxUsageOfCustomers"
                                      placeholder={t("e.g. 10")}
                                      // className={`form-control`}
                                      className={`form-control ${
                                        touched?.limits?.maxUsageOfCustomers &&
                                        errors?.limits?.maxUsageOfCustomers
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      pattern="[0-9]*"
                                      min="0"
                                    />
                                    <TextError name="limits.maxUsageOfCustomers" />
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="row mb-2" style={{ minHeight: 82 }}>
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="amount">
                                    {t("Maximum Discount Amount Per Customer")}
                                  </label>
                                </div>
                                <Switch
                                  isChecked={
                                    values?.discountLimits
                                      ?.isMaxDiscountAmountPerCustomer
                                  }
                                  onClickHandler={() => {
                                    setFieldValue(
                                      "discountLimits.isMaxDiscountAmountPerCustomer",
                                      !values?.discountLimits
                                        ?.isMaxDiscountAmountPerCustomer
                                    )
                                  }}
                                />
                              </div>
                              {values?.discountLimits
                                ?.isMaxDiscountAmountPerCustomer && (
                                <div className="col-lg-6">
                                  <div className="form_field">
                                    <label htmlFor="discountLimits.maxDiscountAmountPerCustomer">
                                      <span className="text-danger">*</span>{" "}
                                      {t(
                                        "Maximum Discount Amount Redemptions Per Customer"
                                      )}
                                    </label>
                                    <Field
                                      type="number"
                                      id="maxDiscountAmountPerCustomer"
                                      name="discountLimits.maxDiscountAmountPerCustomer"
                                      placeholder={t("e.g. 10")}
                                      // className={`form-control`}
                                      className={`form-control ${
                                        touched?.discountLimits
                                          ?.maxDiscountAmountPerCustomer &&
                                        errors?.discountLimits
                                          ?.maxDiscountAmountPerCustomer
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      pattern="[0-9]*"
                                      min="0"
                                    />
                                    <TextError name="discountLimits.maxDiscountAmountPerCustomer" />
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}

                        <div className="col-12 my-4">
                          <div className="d-flex align-items-center justify-content-end">
                            <Button
                              type="button"
                              color="secondary"
                              className=" mx-2"
                              onClick={() => window.history.back()}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              color="success"
                              type="submit"
                              style={{ width: "fit-content" }}
                              disabled={isLoading}
                            >
                              {mode === "add" ? t("Add") : t("Save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                    )
                  }}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddPromotion
